export const config = {
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_CHATBOT_URL: process.env.REACT_APP_CHATBOT_URL,
  REACT_APP_CLIENT_PORTAL_URL: process.env.REACT_APP_CLIENT_PORTAL_URL,
  ZD_CSRF_TOKEN: process.env.ZD_CSRF_TOKEN,
  REACT_APP_MAIN_SPREAD_SHEET_ID: process.env.REACT_APP_MAIN_SPREAD_SHEET_ID,
  REACT_APP_SHARED_FOLDER_ID: process.env.REACT_APP_SHARED_FOLDER_ID,
  REACT_APP_MASTER_FILE_ID: process.env.REACT_APP_MASTER_FILE_ID,
  REACT_APP_AMP_VANTAGE_FOLDER_ID: process.env.REACT_APP_AMP_VANTAGE_FOLDER_ID,
  REACT_APP_AMP_VANTAGE_PDF_FOLDER_ID:
    process.env.REACT_APP_AMP_VANTAGE_PDF_FOLDER_ID,
  REACT_APP_SLIDE_ID: process.env.REACT_APP_SLIDE_ID,
  REACT_APP_SOLAR_STUDY_URL: process.env.REACT_APP_SOLAR_STUDY_URL,
  REACT_APP_MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_EMERSON_MASTER_FILE_ID: process.env.REACT_APP_EMERSON_MASTER_FILE_ID,
  REACT_APP_EMERSON_MAIN_SPREAD_SHEET_ID: process.env.REACT_APP_EMERSON_MAIN_SPREAD_SHEET_ID,
  REACT_APP_EQUITY_CONTRIBUTION_FAQ_LINK: process.env.REACT_APP_EQUITY_CONTRIBUTION_FAQ_LINK,
  REACT_APP_GOOGLE_NO_FORM_URL: process.env.REACT_APP_GOOGLE_NO_FORM_URL,
  REACT_APP_CALENDLY_URL: process.env.REACT_APP_CALENDLY_URL,
  REACT_APP_MISSING_FORM_TOKEN: process.env.REACT_APP_MISSING_FORM_TOKEN,
  REACT_APP_PROFORMA_GENERATOR_MICROSERVICE_BASE_URL: process.env.REACT_APP_PROFORMA_GENERATOR_MICROSERVICE_BASE_URL,
};
